import React from "react";
import CruiseHeaderLanding from "../components/CruiseHeaderLanding";
import banner from "../assets/images/ThemeParkHeader.jpg";
import ThemeParkDetailLanding from "../components/ThemeParkDetailLanding";
import FixThemeParkLanding from "../components/FixThemeParkLanding";
import FamilyTravelCTALanding from "../components/FamilyTravelCTALanding";
import Footer from "../components/Footer";
import PlanningTrip from "../components/PlanningTrip";
import Clients from "../components/Clients";
import TestimonialLanding from "../components/TestimonialLanding";
const ThemeParksLanding: React.FC = () => {
  return (
    <div>
      <CruiseHeaderLanding
        bannerImage={banner}
        bannerText="Turn Crowds and Chaos into Magic and Memories"
      />
      <ThemeParkDetailLanding />
      <FixThemeParkLanding />
      <TestimonialLanding/>
      <FamilyTravelCTALanding />
      <PlanningTrip
        headingplanning="Start Planning Your Family Adventure"
        paragraph="Let us take care of the details while you enjoy quality time with your Family."
      />
      <Clients />
      <Footer />
    </div>
  );
};

export default ThemeParksLanding;
